import { Path } from 'react-hook-form';
import { CollectionMetadata } from '../types';
import { MetadataFieldWrapper } from './MetadataFieldWrapper';
import { useMetadataField } from '../hooks/useMetadataField';
import { TagInput } from '@common/components/TagInput';

export interface TagsMetadataFieldProps {
    name: Path<CollectionMetadata>;
    suggestions?: string[];
    placeholder?: string;
}

export const TagsMetadataField = ({
    name,
    suggestions = [],
    placeholder,
}: TagsMetadataFieldProps) => {
    const hookData = useMetadataField<string[]>({
        name,
        formatOption: (tags) => tags.join(', '),
    });
    const { field } = hookData;

    return (
        <MetadataFieldWrapper {...hookData}>
            <TagInput
                tags={field.value}
                onChange={field.onChange}
                options={{
                    placeholder,
                    suggestions,
                    submitKeys: ['Enter', ','],
                    separators: [',', ';', '\n'],
                }}
            />
        </MetadataFieldWrapper>
    );
};
